import { SitemapItem } from 'src/cms/elasticsearch/types'

export interface CategoryNode {
  documentId: string
  title: string
  slug: string
  children: CategoryNode[]
}

export const buildCategoryTree = (categories: SitemapItem[]): CategoryNode[] => {
  const categoryMap = new Map<string, CategoryNode>()
  const rootCategories: CategoryNode[] = []

  categories.forEach(cat => {
    categoryMap.set(cat.documentId, {
      documentId: cat.documentId,
      title: cat.title,
      slug: cat.slug,
      children: []
    })
  })

  categories.forEach(cat => {
    const node = categoryMap.get(cat.documentId)!

    if (cat.parentDocumentId && categoryMap.has(cat.parentDocumentId)) {
      const parent = categoryMap.get(cat.parentDocumentId)!
      parent.children.push(node)
    } else {
      rootCategories.push(node)
    }
  })

  const sortCategories = (cats: CategoryNode[]) => {
    cats.sort((a, b) => a.title.localeCompare(b.title, 'ro'))
    cats.forEach(cat => {
      if (cat.children.length > 0) {
        sortCategories(cat.children)
      }
    })
  }

  sortCategories(rootCategories)

  return rootCategories
}
